import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n, { loadLanguage } from './shared/i18n/i18n';
import '@/shared/i18n/be-translation.mixin';

import '@/assets/styles/index.scss';
import '@/components/global';
import '@/directives';
import '@/filters';
import '@/init/cookies';
import '@/init/function-extensions';
import '@/init/vue-gtag';
import '@/init/class-component-hooks';
import '@/init/global-properties';
import { Cookie } from './contract/cookies.contract';

Vue.config.productionTip = false;

(async () => {
  try {
    const storedLanguage = Vue.$cookies.get(Cookie.Language);
    await loadLanguage(storedLanguage);
  } finally {
    new Vue({
      i18n,
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  }
})();
